import React from "react";
import { motion } from "framer-motion";
import { LOGO, DISCORD_URL } from "@/components/StarsBackground";
import { Flame, Crosshair } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 pb-24 md:pt-44 md:pb-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-[1.1fr_0.9fr] gap-14 items-center relative z-10">
        <div>
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-xs uppercase tracking-[0.3em] text-white/80"
            data-testid="hero-badge"
          >
            <Flame size={14} style={{ color: "var(--rv-red)" }} />
            Apex · Cronus Zen Values
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display font-black uppercase mt-6 text-4xl sm:text-5xl lg:text-7xl leading-[0.95]"
            data-testid="hero-title"
          >
            Drop in.
            <br />
            <span style={{ color: "var(--rv-red)" }}>Lock on.</span>
            <br />
            <span className="text-white/90">Dominate.</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-white/70 mt-7 max-w-xl text-base sm:text-lg leading-relaxed"
            data-testid="hero-sub"
          >
            Premium Apex Legends sensitivity values and GPC scripts built for the Cronus Zen.
            Tuned by ranked players. Trusted by the lobby. Built to win.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-10 flex flex-wrap gap-4"
          >
            <a href="#pricing" className="btn-primary" data-testid="hero-shop-btn">
              <Crosshair size={16} /> Shop Values
            </a>
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost"
              data-testid="hero-discord-btn"
            >
              Join the Discord
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="relative mx-auto"
          data-testid="hero-logo"
        >
          <div
            className="absolute -inset-10 rounded-full blur-3xl opacity-50"
            style={{ background: "radial-gradient(circle, rgba(230,57,70,0.45), transparent 65%)" }}
          />
          <motion.img
            src={LOGO}
            alt="Rumple's Values"
            className="relative w-72 sm:w-96 lg:w-[440px] aspect-square object-cover rounded-full ring-1 ring-white/10"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
    </section>
  );
}
